// extracted by mini-css-extract-plugin
export default {"addChunkCard":"AddChunkCard_addChunkCard__fdr2q","plus":"AddChunkCard_plus__sunnN","label":"AddChunkCard_label__zU28Y","disabled":"AddChunkCard_disabled__b3n9F"};